import React, { useEffect } from 'react';
import { CountdownProvider } from './contexts/CountdownContext';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { AttentionHero } from './components/AttentionHero';
import { Hero } from './components/Hero';
import { VideoSection } from './components/VideoSection';
import { PainPoints } from './components/PainPoints';
import { Benefits } from './components/Benefits';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <CountdownProvider data-id="element-0" data-mp="2wi5qbra193tj">
      <div className="w-full bg-cream font-sans text-charcoal" data-id="element-1" data-mp="28tw4wqgqei2x">
        <UrgencyBar data-id="element-2" data-mp="28s2xva27hvue" />
        <main data-id="element-3" data-mp="23vkvggucm9l8">
          <AttentionHero data-id="element-4" data-mp="23w4fq47h1a2f" />
          <VideoSection data-id="element-5" data-mp="23ujho4ly78zt" />
          <Hero data-id="element-6" data-mp="23t8g8bfz6dbv" />
          <PainPoints data-id="element-7" data-mp="3ijxnsm94vshs" />
          <Benefits data-id="element-8" data-mp="3ikh5q2ysagvt" />
          <Offer data-id="element-9" data-mp="3ij64a9st9l7v" />
          <Testimonials data-id="element-10" data-mp="3ijpcgysnsv8p" />
          <Faq data-id="element-11" data-mp="3ii4ppvcl6gle" />
          <FinalCta data-id="element-12" data-mp="3mlaxj7fckftz" />
        </main>
        <Footer data-id="element-13" data-mp="3mk852v2dm5by" />
      </div>
    </CountdownProvider>;
}